/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Field errors without the fields just edited (polish pass 2026-10-30): a refusal stayed red under a field after it was
 * put right, until the next «Lagre». The same map back when nothing it names has changed. Pure, so a test can hold it
 * (hooks.ts re-exports it for the views).
 */
export function dropChanged<E extends Record<string, string>>(errors: E, before: Record<string, any>, after: Record<string, any>): E {
  const gone = Object.keys(errors).filter((k) => before[k] !== after[k]);
  return gone.length ? Object.fromEntries(Object.entries(errors).filter(([k]) => !gone.includes(k))) as E : errors;
}
